'use client'

import { hasKitchenDevice } from '@/shared/auth/deviceStorage'
import { hasKitchenSession } from '@/shared/auth/sessionStorage'
import { ClientRedirect } from '@/shared/components/ClientRedirect'
import { useClientHydrated } from '@/shared/hooks/useClientHydrated'

export function KitchenEntryRedirect() {
  const hydrated = useClientHydrated()

  if (!hydrated) {
    return (
      <div className="min-h-[200px] flex items-center justify-center" aria-busy>
        <span className="material-symbols-outlined text-primary text-3xl animate-spin">progress_activity</span>
      </div>
    )
  }

  if (!hasKitchenDevice()) {
    return <ClientRedirect href="/kitchen/activate" />
  }
  if (hasKitchenSession()) {
    return <ClientRedirect href="/kitchen/home" />
  }
  return <ClientRedirect href="/kitchen/login" />
}
